module.exports = __webpack_public_path__ + "img/underline.d1faa2d7.svg";